// Custom dataTransfer type marking a drag that originates from a kanban card, so column
// drop handlers can tell internal card moves apart from OS file drags (mirrors the
// HAMMOCK_DRAG_MIME approach in components/Document/tree/documentTreeDrag.ts).
export const HAMMOCK_KANBAN_DRAG_MIME = 'application/x-hammock-kanban'

export type KanbanDragPayload = {
    itemId: string
    sourceColumnIndex: number
}

export const encodeKanbanDrag = (payload: KanbanDragPayload): string => JSON.stringify(payload)

// Returns the decoded payload, or undefined when the drag did not originate from a kanban
// card (e.g. an OS file drag) or the data is malformed.
export const decodeKanbanDrag = (dataTransfer: DataTransfer): KanbanDragPayload | undefined => {
    if (!dataTransfer.types.includes(HAMMOCK_KANBAN_DRAG_MIME)) {
        return undefined
    }
    try {
        const parsed = JSON.parse(dataTransfer.getData(HAMMOCK_KANBAN_DRAG_MIME))
        if (typeof parsed?.itemId === 'string' && typeof parsed?.sourceColumnIndex === 'number') {
            return parsed as KanbanDragPayload
        }
    } catch {
        // fall through
    }
    return undefined
}
